export default "__VITE_ASSET__CgzW7rXv__"